module.exports = __webpack_public_path__ + "img/game3.014b076f.jpg";